<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="800"
  )
    v-card(:loading="loading")
      v-card-title
        | New Ad

      v-card-text
        v-layout(row reverse)
          v-flex(xs6)
            .preview(:class="form.type")
              .head {{ previewHeadline }}
              .path {{ previewPath }}
              .desc {{ previewDescription }}
          v-flex(xs6)
            v-layout
              v-flex
                v-select(
                  label="Type"
                  v-model="form.type"
                  :items="optAdTypes"
                )

                v-text-field.pt-0.input(
                  v-model="form.final_urls[0]"
                  label="Final URL"
                  hide-details
                )

                .mt-5
                v-text-field.mt-2.input(
                  v-for="k in headlineCount"
                  v-model="form.headlines[k - 1]"
                  :label="'Headline ' + k"
                  :key="'h' + k"
                  hide-details
                )

                .mt-5
                v-text-field.mt-2.input(
                  v-for="k in descriptionCount"
                  v-model="form.descriptions[k - 1]"
                  :label="'Description ' + k"
                  :key="'d' + k"
                  hide-details
                )

                .mt-5
                v-text-field.mt-2.input(
                  v-for="k in 2"
                  v-model="form.paths[k - 1]"
                  :label="'Display Path ' + k"
                  :key="'p' + k"
                  hide-details
                )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" @click="doSubmit") Submit
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import ads from '@/services/googles/ads'

const EXPANDED_TEXT_AD = 'EXPANDED_TEXT_AD'
const RESPONSIVE_SEARCH_AD = 'RESPONSIVE_SEARCH_AD'
const FORM_DEFAULT = {
  type: EXPANDED_TEXT_AD,
  headlines: [],
  descriptions: [],
  final_urls: [],
  paths: []
}

export default {
  props: {
    customerId: [String, Number],
    adGroupId: [String, Number]
  },
  data () {
    return {
      active: false,
      loading: false,
      form: Object.assign({}, FORM_DEFAULT),
      optAdTypes: [
        { text: 'Expended text ad', value: EXPANDED_TEXT_AD },
        { text: 'Responsive search ad', value: RESPONSIVE_SEARCH_AD }
      ]
    }
  },
  mounted () {
  },
  computed: {
    headlineCount () {
      return (this.form.type === EXPANDED_TEXT_AD) ? 2 : 5
    },
    descriptionCount () {
      return (this.form.type === EXPANDED_TEXT_AD) ? 2 : 3
    },
    previewHeadline () {
      return this.form.headlines.filter(v => v).join(' | ') || 'Example headline'
    },
    previewPath () {
      return (this.form.final_urls[0] || 'example.com/') + '/' +
        this.form.paths.filter(v => v).join('/')
    },
    previewDescription () {
      return this.form.descriptions.filter(v => v).join('. ') || 'Example description'
    }
  },
  methods: {
    show () {
      this.active = true
      this.loading = false
      this.form = Object.assign({}, FORM_DEFAULT)
    },
    hide () {
      this.active = false
    },
    doCreateAdExpended () {
      const data = this.form
      const create = {
        ad_group: `customers/${this.customerId}/adGroups/${this.adGroupId}`,
        ad: {
          final_urls: data.final_urls[0],
          expanded_text_ad: {
            headline_part1: data.headlines[0],
            headline_part2: data.headlines[1],
            description: data.descriptions[0],
            description2: data.descriptions[1],
            path1: data.paths[0],
            path2: data.paths[1]
          }
        }
      }
      return ads.addAdGroupAd(this.customerId, create)
    },
    doCreateAdResposive () {
      const data = this.form
      const create = {
        ad_group: `customers/${this.customerId}/adGroups/${this.adGroupId}`,
        ad: {
          final_urls: data.final_urls[0],
          responsive_search_ad: {
            headlines: data.headlines.filter(v => v).map(v => ({ text: v })),
            descriptions: data.descriptions.filter(v => v).map(v => ({ text: v })),
            path1: data.paths[0],
            path2: data.paths[1]
          }
        }
      }
      return ads.addAdGroupAd(this.customerId, create)
    },
    async doSubmit () {
      try {
        this.loading = true
        if (this.form.type === EXPANDED_TEXT_AD) {
          await this.doCreateAdExpended()
        } else if (this.form.type === RESPONSIVE_SEARCH_AD) {
          await this.doCreateAdResposive()
        }

        this.hide()
        this.$emit('complele', true)
      } catch (e) {
        this.loading = false
        const msg = (e.response) ? e.response.data.error.message : e.message
        alert(msg)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-input
  >>> .v-label, >>> input
    font-size: 1rem

.preview
  margin: 0 20px
  padding: 10px 12px
  border: 1px solid #ddd

  > .head
    font-size: 16px
    color: #1a0dab

  > .path
    font-size: 14px
    color: green
    padding-bottom: 4px
    margin-bottom: 5px
    border-bottom: 1px solid #ddd

    &:before
      content: 'Ad'
      display: inline-block
      padding: 0 2px
      margin-right: 8px
      font-size: 13px
      line-height: 12px
      border: 1px solid #006621
      border-radius: 2px
      vertical-align: baseline

  > .desc
    font-size: 14px
</style>
